export default {
  navigation: {
    orders: 'Objednávky',
    search: 'Hledání objednávek',
    packages: 'Balení objednávek',
    customers: 'Zákazníci',
  },

  searchOrder: {
    id: 'Číslo objednávky',
    customerName: 'Jméno zákazníka',
    companyName: 'Název společnosti',
    email: 'E-mail',
    phone: 'Telefon',
    createdAtFrom: 'Vytvoření objednávky - od',
    createdAtTo: 'Vytvoření objednávky - do',
    shippingMethod: 'Způsob dopravy',
    shippingOption: 'Pobočka',
    paymentMethod: 'Způsob platby',
    status: 'Stav objednávky',
    priceProm: 'Cena od',
    priceTo: 'Cena do',
    country: 'Země',
    productName: 'Název produktu',
    brandName: 'Výrobce produktu',
    productSKU: 'SKU produktu',
    productEan: 'EAN produktu',
    packageNumber: 'Číslo zásilky',
    customerGroup: 'Zákaznická skupina',
    filter: 'Filtrovat',
    delete_filter: 'Resetovat filtry',
    status_all: 'Nerozhoduje',
    status_active: 'Aktivní',
    status_inactive: 'Neaktivní',
  },

  user: {
    login: 'Přihlásit se',
    logout: 'Odhlásit se',
    logForm: 'Přihlašovací formulář',
    activationForm: 'Aktivační formulář',
    resetPasswordConfirmForm: 'Potvrzovací formulář pro obnovu hesla',
    activation: 'Aktivovat',
    passwordChange: 'Změnit heslo',
    forgottenPassword: 'Zapomenuté heslo',
    password: 'Heslo',
    passwordConfirm: 'Potvrzení hesla',
  },

  search: {
    generic: 'Vyhledávání',
    orders: 'Vyhledávejte v objednávkách',
    name: 'Vyhledávejte podle jména',
    text: 'Vyhledávejte podle textu',
    idOrEmail: 'Vyhledávejte dle ID nebo e-mailu',
    usernameOrEmail: 'Vyhledávejte podle jména nebo e-mailu',
    itemName: 'Vyhledávejte podle názvu',
    itemNameEmailOrId: 'Vyhledávejte podle názvu, emailu, nebo čísla',
    orderCodeOrName: 'Vyhledávejte podle čísla nebo jména',
    numberOrCustomer: 'Hledejte podle čísla nebo jména zákazníka',
  },

  dataIterator: {
    noResultsText: 'Žádné záznamy',
    noResultsIn7Days: 'Žádné záznamy za posledních 7 dní',
    loadingText: 'Načítání...',
  },
  dataTable: {
    itemsPerPageText: 'Řádků na stránku:',
    ariaLabel: {
      activateDescending: ': Sorted descending. Activate to remove sorting.',
      activateAscending: ': Sorted ascending. Activate to sort descending.',
      activateNone: ': Not sorted. Activate to sort ascending.',
      sortDescending: ': Sorted descending. Activate to remove sorting.',
      sortAscending: ': Sorted ascending. Activate to sort descending.',
      sortNone: ': Not sorted. Activate to sort ascending.',
    },
    sortBy: 'Řadit podle',
    number: 'Číslo',
    createdAt: 'Datum',
    customerName: 'Zákazník',
    orderState: 'Status',
    paymentMethod: 'Platba',
    shippingMethod: 'Doprava',
    invoicesCount: 'Počet faktur',
    price: 'Cena',
  },
  dataFooter: {
    pageText: '{0}-{1} z {2}',
    itemsPerPageText: 'Položek na stránku:',
    itemsPerPageAll: 'Vše',
    nextPage: 'Další stránka',
    prevPage: 'Předchozí stránka',
    firstPage: 'První stránka',
    lastPage: 'Poslední stránka',
  },
  fileInput: {
    counter: 'Vybráno celkem souborů: {0}',
  },
  noDataText: 'Nejsou dostupná žádná data',

  datePicker: {
    itemsSelected: '{0} zvoleno',
    prevMonthAriaLabel: 'Předchozí měsíc',
    nextMonthAriaLabel: 'Následující měsíc',
  },

  timePicker: {
    pm: 'PM',
    am: 'AM',
  },

  orders: {
    detail: 'Detail objednávky {0}',
    cancel: 'Zrušit objednávku {0}',
    confirmChanges: 'Potvrdit a inkasovat',
  },

  currency: {
    country: {
      CZE: 'Kč',
      SVK: 'EUR',
    },
  },

  customers: {
    back: 'Zpět',
    or: 'nebo',
    createCustomer: 'Vytvořit zákazníka',
    addSale: 'Připsat prodej',
    addSaleInput: {
      CZE: 'Zadejte celkovou částku nákupu v Kč',
      SVK: 'Zadejte celkovou částku nákupu v EUR',
    },
    addSaleButton: 'Připsat kredity za nákup',
    credits: 'kreditů',
    addLoyaltyCard: 'Přidejte ID kartičky k uživateli',
    addComment: 'Přidejte další komentář k uživateli',
    cardId: 'ID kartičky',
    autoComments: {
      card: 'Karta ',
      addedWithRegistration: ' byla přidána při registraci.',
      added: ' byla přidána.',
      removed: ' byla odebrána.',
    },
  },

  tabs: {
    basicInfo: 'Obecné informace',
    seo: 'SEO',
    og: 'OG',
    images: 'Obrázky',
    properties: 'Vlastnosti',
    tags: 'Štítky',
    credits: 'Kredity',
    reports: 'Nahlášení',
    pages: 'Stránky',
    keywords: 'Klíčová slova',
    paid: 'Placené',
    unpaid: 'Neplacené',
    attendance: 'Návštěvnost',
    location: 'Lokalita',
    devices: 'Zařízení',
    attendanceSources: 'Zdroje návštěv',
  },

  cards: {
    basicInfo: 'Obecné informace',
    information: 'Informace',
    orderState: 'Stav objednávky',
    image: 'Obrázek',
    images: 'Obrázky',
    heroImage: 'Úvodní fotka',
  },

  labels: {
    actualOrderState: 'Aktuální stav objednávky',
    companyName: 'Název společnosti',
    companyIdNumber: 'IČ',
    companyVatNumber: 'DIČ',
    dispensing: 'Výdejna',
    takeProfit: 'Inkasovat',
    shop: 'Prodejna',
    settings: 'Nastavení účtu',
    clearMetadata: 'Vymazat mezipaměť',
    saveChanges: 'Vytvořit doklad',
    resetChanges: 'Zrušit změny',
    orderDate: 'Datum objednávky',
    orderState: 'Stav objednávky',
    paidAt: 'Zaplaceno',
    notPaidYet: 'Objednávka ještě nebyla zaplacena',
    ip: 'IP',
    showCustomersComments: 'Zobrazit komentáře k zákazníkovi',
    noNote: 'Zákazník nezanechal poznámku',
    noShopNote: 'Obchod nezanechal poznámku',
    showOnMap: ' Zobrazit na mapě',
    withoutWat: 'bez DPH',
    orderedItems: 'Položky objednávky',
    orderedItemsCount: '(celkem {0} produktů / {1} kusů)',
    weight: 'Váha',
    note: 'Poznámka',
    customerNote: 'Poznámka zákazníka',
    shopNote: 'Poznámka obchodu',
    info: 'Informace',
    subtotal: 'Mezisoučet',
    wat: 'DPH',
    typeOfOrder: 'Typ objednávky',
    shipping: 'Doprava',
    payment: 'Platba',
    total: 'Celkem',
    newTotal: 'Nová cena celkem',
    customer: 'Zákazník',
    notFilled: 'Nevyplněno',
    billingAddress: 'Fakturační adresa',
    shippingAddress: 'Dodací adresa',
    orderFound: 'Nalezena objednávky č.',
    goToOrder: 'Přejít na detail',
    logout: 'Odhlásit',
    send: 'Odeslat',
    customerRegistered: 'Registrovaný zákazník',
    stornoAll: 'Stornovat vše',
    orderId: 'Číslo objednávky',
    itemsCount: 'Počet položek',
    finalTaxedPrice: 'Finální celková cena',
    creditAmount: '(počet: {0})',
  },

  messages: {
    customerWithIdDoesNotExistCreatePrompt: 'Zákazník s ID {0} neexistuje. Chcete ho vytvořit?',
    noNote: 'Zákazník nezanechal poznámku',
    forSearchStartTyping: 'Pro vyhledávání začněte psát…',
    deleteConfirm: 'Opravdu si přejete smazat tuto položku',
    invalidData: 'Nevalidní data',
    fieldRequired: 'Pole je povinné',
    fieldLength: 'Pole přesahuje délku {0} znaků',
    greaterThanZero: 'Musí být větší než nula',
    lesserThan65535: 'Musí být menší než 65535',
    longerThanEight: 'Musí mít alespoň 8 znaků',
    passwordsMustMatch: 'Hesla se musejí shodovat',
    wrongEmailFormat: 'Neplatný formát e-mailu',
    messagesSent: 'Hromadná zpráva úspěšně odeslána',
    onlyHourAndMinutes: 'Zadejte pouze hodiny a minuty oddělené ":"',
    mustContainColon: 'Musí obsahovat ":"',
    passwordResetRequestSent:
      'Žádost o obnovení hesla byla odeslána, odkaz pro nastavení nového hesla vám přijde na e-mail',
    creditNoteCreated: 'Dobropis byl úspěšně vytvořen',
    accessDenied: 'Pro tuto akci nemáte oprávnění',
    greaterThan: 'Hodnota musí být větší než {0}',
    attributeCreatedSuccessfully: 'Atribut úspěšně vytvořen',
    attributeUpdatedSuccessfully: 'Atribut úspěšně upraven',
    itemMovedSuccesfully: 'Položka přemístěna úspěšně',
    noCategories: 'Zatím nemáte žádnou kategorii',
    noMoreThanTwoTags: 'K inzerátu nelze přidat více jak dva štítky',
    mustContainDialCode: 'Telefon musí obsahovat i předvolbu',
    googleSignInRequired:
      'Pro přístup k informacím je nejdříve nutné se přihlásit pomocí účtu napojeném na Google Analytics a vybrat časový interval',
    cameraNotAllowedError: 'Musíte povolit přístup ke kameře',
    cameraNotFoundError: 'Na tomto zařízeni nebyla nalezena kamera',
    cameraNotReadableError: 'Nepoužívate již kameru jinde?',
    cameraOverconstrainedError: 'Používaná kamera není vhodná',
    cameraStreamApiNotSupportedError: 'Váš prohlížeč nepodporuje toto rozhraní',
    confirmOrderChange: 'Potvrzením se vytvoří daňový doklad.',
    latestOrderChange: 'Obj. č. <strong>{0}</strong> na <strong>{1} ks</strong> celkem za <strong>{2}</strong> úspěšně upravena. Můžete pokračovat na další objednávku. ',
    confirmOrderCancellation: 'Potvrzením zrušíte objednávku č. <strong>{0}</strong>.',
    orderSuccessfullyUpdated: 'Objednávka byla úspěšně upravena',
    orderSuccessfullyCancelled: 'Objednávka byla úspěšně zrušena',
    carrier: 'Dobírka',
    successfulyCreated: 'Úspěšně vytvořeno',
    customerFound: 'Zákazník nalezen',
    customerNotFound: 'Zákazník nenalezen',
    creditsAdded: 'Úspěšně připsáno',
    invalidAmount: 'Zadejte prosím platnou hodnotu',
    updateError: 'Byla vydána nová verze aplikace, prosím přenačtěte si stránku.',
    cardNotExist: 'Neexistující karta',
    cardAlreadyUsed: 'Tuto kartu už někdo přiřazenou má',
    customerNotFoundByCard: 'Nepodařilo se vyhledat zákazníka podle karty',
    commentNotAdded: 'Nepodařilo se přidat komentář k uživateli',
  },

  basic: {
    yes: 'Ano',
    no: 'Ne',
    active: 'Aktivní',
    notActive: 'Neaktivní',
    solved: 'Odbaveno',
    notSolved: 'Neodbaveno',
    ok: 'OK',
    confirm: 'Potvrdit',
    cancel: 'Zrušit',
    create: 'Vytvořit',
    locked: 'Uzamčené',
    insertName: 'Vložte název',
    goToOrderDetail: 'Přejít na detail objednávky',
    name: 'Jméno',
    surname: 'Příjmení',
    email: 'E-mail',
    phone: 'Telefon',
    id: 'ID',
  },

  errors: {
    allFields: 'Vyplňte všechna povinná pole',
    gdpr: 'Musíte udělit souhlas s obchodními podmínkami a se zpracováním osobních údajů',
  },

  time: {
    lessThanOneDay: 'Dní',
    oneDay: 'Den',
    lessThanFiveDays: 'Dny',
    moreThanFiveDays: 'Dní',
    lessThanOneHour: 'Hodin',
    oneHour: 'Hodina',
    lessThanFiveHours: 'Hodiny',
    moreThanFiveHours: 'Hodin',
  },

  close: 'Zavřít',
};
